/* unplugin-vue-components disabled */
import {markRaw} from 'vue'
import PulseButton from '../pulse-button.vue'
import FeedCalendar from './feed-calendar.vue'
import PulseEntities from './feed-entities.vue'
import FeedSearch from './feed-search.vue'
import {CATEGORIES} from 'consts/categories'
import PulseTooltip from '../pulse-tooltip.vue'

export default {
  components: {FeedCalendar, PulseEntities, FeedSearch, PulseButton, PulseTooltip},
  mixins: [ModelValue(Object)],
  props: {
    categoriesCount: {type: Object, required: true},
    semanticSearch: {type: Boolean, required: false},
    loading: {type: Boolean, required: false},
    allCount: {type: [String, Number], default: undefined},
    hasFilters: {type: Boolean, default: false},
  },
  emits: ['update-filters', 'clear'],
  data() {
    return {      
      CATEGORIES: markRaw(CATEGORIES)
    }
  },
  computed: {
    active_filter() {
      if (this.semanticSearch) return
      return this.value.category
    }
  },
  methods: {
    clearEntities(){
      this.$refs.entities.clearAll()
    },
    reloadEntities(){
      this.$refs.entities.loadItems()
    },
    setEntity(id){
      this.$refs.entities.setEntity(id)
    },
  }
}

